'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _lodash = require('lodash');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

var _AddressBookIndex = require('./components/AddressBookIndex');

var _AddressBookIndex2 = _interopRequireDefault(_AddressBookIndex);

var _AddressBookAdd = require('./components/AddressBookAdd');

var _AddressBookAdd2 = _interopRequireDefault(_AddressBookAdd);

var _AddressBookEdit = require('./components/AddressBookEdit');

var _AddressBookEdit2 = _interopRequireDefault(_AddressBookEdit);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oneOf = _react.PropTypes.oneOf,
    func = _react.PropTypes.func,
    shape = _react.PropTypes.shape,
    arrayOf = _react.PropTypes.arrayOf,
    string = _react.PropTypes.string,
    number = _react.PropTypes.number;
var AddressBook = (_dec = (0, _reactCssModules2.default)(_style2.default), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AddressBook, _React$Component);

  function AddressBook() {
    (0, _classCallCheck3.default)(this, AddressBook);
    return (0, _possibleConstructorReturn3.default)(this, (AddressBook.__proto__ || (0, _getPrototypeOf2.default)(AddressBook)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressBook, [{
    key: 'getEditingAddress',
    value: function getEditingAddress() {
      var _this2 = this;

      return (0, _lodash.find)(this.props.addresses, function (a) {
        return a.id === _this2.props.editingAddressId;
      });
    }
  }, {
    key: 'renderPage',
    value: function renderPage() {
      switch (this.props.page) {
        case 'AddressList':
          return _react2.default.createElement(_AddressBookIndex2.default, {
            onAdd: this.props.onAdd,
            onEdit: this.props.onEdit,
            onSelect: this.props.onSelect,
            onChoice: this.props.onChoice,
            onDelete: this.props.onDelete,
            addressType: this.props.addressType,
            selectedAddressId: this.props.selectedAddressId,
            addresses: this.props.addresses
          });
        case 'AddAddress':
          return _react2.default.createElement(
            _Form2.default,
            { onSubmit: this.props.onCreate },
            _react2.default.createElement(_AddressBookAdd2.default, {
              onCancel: this.props.onCancel
            })
          );
        case 'EditAddress':
          return _react2.default.createElement(
            _Form2.default,
            { onSubmit: this.props.onUpdate },
            _react2.default.createElement(_AddressBookEdit2.default, {
              onCancel: this.props.onCancel,
              address: this.getEditingAddress()
            })
          );
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'address-book-blackout' },
        _react2.default.createElement('div', { styleName: 'close-on-click', onClick: this.props.onClose }),
        _react2.default.createElement(
          'div',
          { styleName: 'address-book-modal' },
          _react2.default.createElement(
            'a',
            { styleName: 'close-link', onClick: this.props.onClose },
            _react2.default.createElement(_Icon2.default, { type: 'cross' })
          ),
          this.renderPage()
        )
      );
    }
  }]);
  return AddressBook;
}(_react2.default.Component), _class2.propTypes = {
  editingAddressId: string,
  onAdd: func.isRequired,
  onCancel: func.isRequired,
  onClose: func.isRequired,
  onCreate: func.isRequired,
  onDelete: func.isRequired,
  onEdit: func.isRequired,
  onSelect: func.isRequired,
  onChoice: func.isRequired,
  onUpdate: func.isRequired,
  addressType: string.isRequired,
  selectedAddressId: number,
  page: oneOf(['AddressList', 'AddAddress', 'EditAddress']).isRequired,
  addresses: arrayOf(shape({ id: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
    company: string.isRequired,
    address1: string.isRequired,
    address2: string.isRequired,
    city: string.isRequired,
    state: string.isRequired,
    postcode: string.isRequired
  }))
}, _temp)) || _class);
exports.default = AddressBook;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/index.js
// module id = 2260
// module chunks = 0